<template>
    <div>
        
        <mdb-row>
        <mdb-col md="12" style="margin-bottom: 10px;">
            <div class="form__group">
                <p class="text-general">
                    Para trámite de solicitud de admisión como usuario propietario <strong>deberás colocar los datos 
                    de facturación a tu nombre.</strong>
                </p>
            </div>
        </mdb-col>
        </mdb-row>

     



		<mdb-row>
		
			<mdb-col md="6" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label for="benReaseS" class="form__label">Nombre o razón social:</label>
						<input v-model="businessSocialReason" type="text" id="benReaseS" class="form__input" value=""/>
						<validation-error :validation="$v.businessSocialReason" />
					</div>
				</div>
			</mdb-col>

		</mdb-row>


		<mdb-row>
			 
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label  for="benBillrfc" class="form__label">RFC:</label>
						<input v-model="rfc" type="text" id="benBillrfc" class="form__input" value="" v-mask="'XXXXXXXXXXXXX'"/>
						<validation-error :validation="$v.rfc" />
					</div>
				</div>
			</mdb-col>

		</mdb-row>


    
       <mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label for="beneficiary-state" class="form__label">Estado:</label>
						<input disabled type="text" v-model="state" id="beneficiary-state" class="form__input" value="" />
						<validation-error :validation="$v.state" />
					</div>
				</div>
			</mdb-col>

				<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label for="beneficiary-city" class="form__label">Ciudad:</label>
						<input disabled type="text" v-model="city" id="beneficiary-city" class="form__input" value="" />
						<validation-error :validation="$v.city" />
					</div>
				</div>
			</mdb-col>
		</mdb-row>



		<mdb-row>
			<mdb-col md="2" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label class="form__label">CP.:</label>
						<input v-model="codePostal" v-mask="'#####'" @change="getLocations" type="text"  class="form__input" value="" />
						<validation-error :validation="$v.codePostal" />
					</div>
				</div>
			</mdb-col> 
		</mdb-row>
 

        <mdb-row>
				<mdb-col md="8" style="margin-bottom: 20px;">
					<label   class="form__label">Colonia:</label>
					
					<select v-model="locationId" class="browser-default custom-select">
						<option v-for="(item, index) in listColony" :key="index" :value="item.id">{{ item.colony }}</option>
					</select>
					<validation-error :validation="$v.locationId" />

				</mdb-col>
				
		</mdb-row>


        <mdb-row>
					
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label  class="form__label">Calle:</label>
						<input v-model="street"  type="text"  class="form__input" value="" style="text-transform: capitalize !important;" />
						<validation-error :validation="$v.street" />
					</div>
				</div>
			</mdb-col> 

				<mdb-col md="2" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label  class="form__label">Nº Ext.:</label>
						<input v-model="externalNumber" type="text"  class="form__input" value="" />
						<validation-error :validation="$v.externalNumber" />
					</div>
				</div>
			</mdb-col> 

				<mdb-col md="2" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label  class="form__label">Nº Int.:</label>
						<input type="text" v-model="interiorNumber"  class="form__input" value="" />
					</div>
				</div>
			</mdb-col> 
		</mdb-row>
       
         
    </div>
</template>
<script>
    import Btn from '../../core/Button';
	import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
	import { mapActions, mapGetters, mapMutations } from "vuex";
	import { mask } from "vue-the-mask";
	import Popup from "../../core/Popup";
	import vSelect from "vue-select";
	import ValidationError from "../misc/ValidationError";
	import { required, email, minLength, alphaNum, maxLength, sameAs } from "vuelidate/lib/validators";


  export default {
    name: "BeneficiaryBillData",
    components: {
			mdbContainer,
			mdbRow,
			vSelect,
			mdbCol,
			Btn,
			Popup,
			ValidationError,
		},
	  directives: { mask },
    data(){
      return{
                codePostal: "",
                listColony: [],
                colony: "",
                state:"",
                city:"",
                billingType: '',
                rfc:"",
                businessSocialReason:"",
                email:"",
                phone:"",
                street:"",
                externalNumber:"",
                interiorNumber:"",
            	  locationId:"",
      }
	  },
	  validations: {
			locationId: {required},
			state: {required},
			city: { required },
			rfc: { required, minLength: minLength(13), maxLength: maxLength(13), },
			businessSocialReason: { required },
			street: { required },
			externalNumber: { required },
			codePostal: { required },
	  },
	  created(){
			this.userAllData = JSON.parse(localStorage.getItem("userAllData"));
			if(this.userAllData.billingInformation != null){
			this.rfc =  this.userAllData.billingInformation.rfc;
			this.businessSocialReason = this.userAllData.billingInformation.businessSocialReason;

			if(this.userAllData.billingInformation.address != null){
					let locID = this.userAllData.billingInformation.address.location.id;
					//console.log("locID", locID);
					this.locationId = locID;
					this.getLocationsByID();
				}
			}


	  },
    methods: {
		  ...mapActions([
			  "obtainLocationsDoc",
			  "obtainLocationByID"
			]),

      async getLocations() {
				if (this.codePostal.length == 5) {
					let response = await this.obtainLocationsDoc(this.codePostal);
					//console.log("response getLocations", response)
					if (response.data) {
					this.listColony = response.data.data;
					//console.log("listColony", this.listColony);
					this.state = response.data.data[0].state;
					this.city = response.data.data[0].city!=''?response.data.data[0].city:response.data.data[0].municipality;
					this.locationId = response.data.data[0].id;
					}
				}
			},

			async getLocationsByID() {
					
				let response = await this.obtainLocationByID(this.locationId);
				//console.log("response getLocationsByID Billing", response); 
				if (response.data) {
						//this.listColony = response.data.data;
						//console.log("listColonyXX", this.listColony);
						this.state = response.data.data.state;
						this.city = response.data.data.city;
						this.colony = response.data.data.colony;

						this.codePostal = response.data.data.zipCode;
						this.setNewColonyList();
					
						this.street = this.userAllData.billingInformation.address.street;
						this.externalNumber = this.userAllData.address.externalNumber;
						this.interiorNumber = this.userAllData.address.interiorNumber;
				}
					
			},

			async setNewColonyList(){
					let response = await this.obtainLocationsDoc(this.codePostal);
					if (response.data) {
						this.listColony = response.data.data;
						//console.log("listColony", this.listColony);
						this.state = response.data.data[0].state;
						this.city = response.data.data[0].city;
						this.locationId = response.data.data[0].id;
					}
			},

			getFormdata() {
					//console.log("GET FORM DATA")
                
				this.$v.$touch();

				if (this.$v.$invalid){
          return false;
        }
       else {
					var billingData = { 
              rfc:this.rfc, 
              businessSocialReason:this.businessSocialReason,
              address: {
                street: this.street,
                externalNumber: this.externalNumber,
                interiorNumber: this.interiorNumber,
                locationId: this.locationId
              }

          }
				//console.log("billinData", billingData);
          return billingData;
      }


 
      }

    },

    watch: {
      codePostal(val){
        if(val.length == 5){
          this.getLocations()
        }
      }
    },

  }
</script>

<style>
.text-general{
    font-size: 16px;
    line-height:18px;
}

.text-general strong{
    font-weight: 600;
}

</style>